module.exports = __webpack_public_path__ + "img/advantagesImg3.39ddd4ef.png";